export function millisecondsToString (milliseconds) {
    // Render a remaining-time string like "1h 59m 03s". Always includes
    // seconds so the countdown ticks, and never returns an empty string.
    if (!milliseconds || isNaN(milliseconds) || milliseconds < 0) {
        return '0s'
    }

    const totalSeconds = Math.floor(milliseconds / 1000)
    const d = Math.floor(totalSeconds / (60 * 60 * 24))
    const h = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60))
    const m = Math.floor((totalSeconds % (60 * 60)) / 60)
    const s = totalSeconds % 60

    const components = []
    if (d) { components.push(`${d}d`) }
    if (h) { components.push(`${h}h`) }
    if (m) { components.push(`${m}m`) }
    // pad seconds when shown alongside larger units, e.g. "1m 05s"
    components.push(components.length ? `${String(s).padStart(2, '0')}s` : `${s}s`)

    return components.join(' ')
}

export function formatAmount (amount, currency) {
    const value = Number(amount)
    const formatted = isNaN(value) ? amount : value.toLocaleString()
    return currency ? `${formatted} ${currency}` : `${formatted}`
}
